import 'prop-types';
import styled from 'styled-components';

var CheckboxIcon = styled.div.withConfig({
  displayName: "CheckboxIcon",
  componentId: "sc-h2tj18-0"
})(["&&{display:flex;align-items:center;justify-content:center;border-radius:", "px;border:2px solid ", ";height:", "px;width:", "px;}"], function (props) {
  return props.size > 19 ? 4 : 3;
}, function (props) {
  return props.theme.neutralColors.smoke;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
});

export { CheckboxIcon };
